<!--

	Default website radio button control.

-->
<template>
	<div class="mia-RadioButtonWrapper" @click="input">
		<input
			type="radio"
			:name="groupName"
			:value="valueChoice"
			:checked="modelValue === valueChoice"
			class="mia-radioButtonInput"
		>
		<slot />
	</div>
</template>

<script lang="ts">
import { Component, Prop, Vue, toNative } from "vue-facing-decorator";

@Component({
	emits: ["update:modelValue"],
})
export class RadioButton extends Vue {
	@Prop({ required: false, type: String }) modelValue!: string;
	@Prop({ required: true, type: String }) valueChoice!: string;
	@Prop({ required: false, type: String }) groupName!: string;

	input() {
		this.$emit("update:modelValue", this.valueChoice);
	}
}

export default toNative(RadioButton);
</script>

<style lang="scss">
// We called it mia-RadioButtonWrapper since mia-RadioButtonContainer is already taken

// The styles for the legacy server-rendered radio buttons are located in wwwroot/SASS/shared/lib/_radioButton.scss
.mia-RadioButtonWrapper {
	cursor: pointer;
	display: flex;
	align-items: center;

	.mia-radioButtonInput {
		appearance: none;
		width: theme.$mia-icon-size;
		height: theme.$mia-icon-size;
		border: theme.$mia-border-width-panel-small solid
		theme.$mia-color-checkboxUnchecked;
		border-radius: theme.$mia-border-radius-big;
		vertical-align: middle;
		cursor: pointer;
	}

	.mia-radioButtonInput:checked {
		border: theme.$mia-border-width-panel-xl solid theme.$mia-color-themeMain-500;
		border-radius: theme.$mia-border-radius-big;
	}

	.mia-radioButtonInput:focus {
		outline: 0;
	}

	label {
		display: inline-block;
		vertical-align: middle;
		margin-top: theme.$mia-buttons-margin;
		margin-left: theme.$mia-buttons-margin;
		font-weight: normal;
		cursor: pointer;
	}
}
</style>
